import React, { useEffect, useState } from "react";
import Axios from "axios";
import { GetJobPostsByID} from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { useCountry } from '../contexts/countrycodecontext.js';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewJobPosts = () => {
    let query = useQuery();
    const guid = query.get("guid");
    const jobPost= query.get("jobPost")
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
      const { selectedCountry} = useCountry();
    const GetCandidateDetails = () => {
        setIsLoading(true);
        const GetapiUrl =`${GetJobPostsByID.APIURL}?JobPostID=${jobPost}`;
        Axios.get(GetapiUrl)
            .then((result) => {
                setIsLoading(false);
                setCandidateDetails(result.data[0]);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
            });
    };
  
    useEffect(() => {
        GetCandidateDetails();
    }, []);

    return (
        <ConsultantLayout>
            {candidateDetails ? (
                < div class="container-fluid">
                <div className='mb-3 mt-3 mr-3'  style={{ display: 'flex', alignItems: 'center' }}>
                        <Link to="/Employer/ListOfJobPosts">
                            <i className="fa fa-arrow-left mr-3" style={{ color: "#00a7ac", fontSize: 16 }} aria-hidden="true"></i>
                        </Link>
                        <h2 className="" style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Job Details</h2>
                    </div>
                    <hr />
                    
                    <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                         <div class="row mt-2">
                   
                    
                    <div class="col-sm-12 col-lg-6 col-xl-6 col-md-6">

                 <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Title</Tooltip>}>
                        <p className="text-para "><i className="fas fa-heading icons"></i> {candidateDetails.title}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Location</Tooltip>}>
                        <p className="text-para"><i className="fas fa-map-marker-alt icons"></i> {candidateDetails.location}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Job Type</Tooltip>}>
                        <p className="text-para"> <i className="fas fa-briefcase icons"></i> {candidateDetails.jobType}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-fullName">Positions</Tooltip>}>
                        <p className="text-para"><i className="fa fa-user icons"></i> {candidateDetails.positions}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Client Name</Tooltip>}>
                        <p className="text-para"><i className="fas fa-user-tie icons"></i> {candidateDetails.clientName}</p>
                    </OverlayTrigger>
                      {candidateDetails.endClient!=null &&candidateDetails.endClient!="null" && candidateDetails.endClient!="" && <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">End Client Name</Tooltip>}>
                        <p className="text-para"><i className="fas fa-user-tie icons"></i> {candidateDetails.endClient}</p>
                    </OverlayTrigger> }
                    <OverlayTrigger  placement="bottom"  overlay={<Tooltip id="tooltip-mobileNumber">{selectedCountry == 2 ? "Bill Rate" : "Expected CTC"} </Tooltip>}>
                     <p className="text-para"> <i className="fas fa-money-bill-wave icons"></i> {candidateDetails.billRate}  </p>
                    </OverlayTrigger>
     {candidateDetails.payRate!=null &&candidateDetails.payRate!="null" &&candidateDetails.payRate!="" &&
     <OverlayTrigger  placement="bottom"  overlay={<Tooltip id="tooltip-mobileNumber">{selectedCountry == 2 ? "Pay Rate" : "Current CTC"} </Tooltip>}>
                     <p className="text-para"> <i className="fas fa-money-bill-wave icons"></i> {candidateDetails.payRate}  </p>
                    </OverlayTrigger>}
                    <div className="commenttt-wrapper"> <i className="fas fa-file-alt icons mt-2 mr-2"></i> 
                        <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-email">Job Description</Tooltip>}>
                         <p className="text-paraaa"> {parse(DOMPurify.sanitize(candidateDetails.jobDescription))}</p>
                    </OverlayTrigger>
                    </div>
                       
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Start Date</Tooltip>}>
                        <p className="text-para"> <i className="fas fa-calendar-alt icons"></i> {candidateDetails.startDate.split('T')[0]}</p>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">End Date</Tooltip>}>
                        <p className="text-para"> <i className="fas fa-calendar-alt icons"></i> {candidateDetails.endDate.split('T')[0]}</p>
                    </OverlayTrigger>
                         {candidateDetails?.outreach_Status!=null &&candidateDetails?.outreach_Status!="null" &&candidateDetails?.outreach_Status!="" &&

                      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Outreach Status</Tooltip>}>
                        <p className="text-para"> <i className="fa fa-chart-line icons"></i> {candidateDetails?.outreach_Status}</p>
                    </OverlayTrigger>
}
          {candidateDetails?.outreach_Type!=null &&candidateDetails?.outreach_Type!="null" &&candidateDetails?.outreach_Type!="" &&

                      <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-mobileNumber">Outreach Type</Tooltip>}>
                        <p className="text-para"> <i className="fa fa-users icons"></i> {candidateDetails?.outreach_Type}</p>
                    </OverlayTrigger>
}
                  </div>
                 </div>
                </div>
</div>
            ) : (
                <center><LoadingSpinner /></center>
            )}
        </ConsultantLayout>
    );
};

export default ViewJobPosts;
